"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Debug mode wrapper for middleware functions.
 */

function debugMiddleware(middleware) {
  if (!Array.isArray(middleware)) {
    throw new TypeError("Expected middleware to be an array, got ".concat(_typeof(middleware)));
  }

  var _iterator = _createForOfIteratorHelper(middleware),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;

      if (typeof fn !== "function") {
        // tslint:disable-line
        throw new TypeError("Expected middleware to contain functions, but got ".concat(_typeof(fn)));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return function composedDebug(ctx, done) {
    if (typeof done !== "function") {
      // tslint:disable-line
      throw new TypeError("Expected the last argument to be `done(ctx)`, but got ".concat(_typeof(done)));
    }

    var index = 0;

    function dispatch(pos) {
      var fn = middleware[pos] || done;
      index = pos;
      return new Promise(function (resolve) {
        var result = fn(ctx, function next() {
          if (pos < index) {
            throw new TypeError("`next()` called multiple times");
          }

          if (pos > middleware.length) {
            throw new TypeError("Composed `done(ctx)` function should not call `next()`");
          }

          return dispatch(pos + 1);
        });

        if (result === undefined) {
          // tslint:disable-line
          throw new TypeError("Expected middleware to return `next()` or a value");
        }

        return resolve(result);
      });
    }

    return dispatch(index);
  };
}
/**
 * Production-mode middleware composition (no errors thrown).
 */


function composeMiddleware(middleware) {
  function dispatch(pos, ctx, done) {
    var fn = middleware[pos] || done;
    return new Promise(function (resolve) {
      return resolve(fn(ctx, function next() {
        return dispatch(pos + 1, ctx, done);
      }));
    });
  }

  return function composed(ctx, done) {
    return dispatch(0, ctx, done);
  };
}
/**
 * Compose an array of middleware functions into a single function.
 */


exports.compose = process.env.NODE_ENV === "production" ? composeMiddleware : debugMiddleware;